/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ElencoAssetDto interface.
 */
export function instanceOfElencoAssetDto(value) {
    return true;
}
export function ElencoAssetDtoFromJSON(json) {
    return ElencoAssetDtoFromJSONTyped(json, false);
}
export function ElencoAssetDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'pricing': json['pricing'] == null ? undefined : json['pricing'],
    };
}
export function ElencoAssetDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'pricing': value['pricing'],
    };
}
